import axios from 'axios'
import {Message} from 'element-ui'
import i18n from '../i18n'
import token from '@/plugins/token'
import router from '@/router'
import whiteList from './whiteList'
import * as session from '@/plugins/session'

const service = axios.create({
  baseURL: process.env.BASE_URL,
  timeout: 10000,
  headers: {
    'Content-Type': 'application/json'
  }
})

const urlWhiteList = ['/startSession']

const goLogin = function(){
  const tip = sessionStorage.getItem('tip_msg')
  const userName = sessionStorage.getItem('user_uid')
  session.clean()
  if(userName !== null){
    sessionStorage.setItem('tip_msg',i18n.t('error.axios.401'))
  }
  if(tip !== null){
    sessionStorage.setItem('tip_msg',tip)
  }
  router.go(0)
}

service.interceptors.request.use(
  config => {
    if (!urlWhiteList.includes(config.url)) {
      if(!whiteList.includes(config.url)){
        config.headers.token = token.create()
      }
      config.headers.ssid = sessionStorage.getItem('ss_id')
      const { 'Content-Type': contentTypeValue } = config.headers
      if(contentTypeValue !== null && contentTypeValue !== undefined && contentTypeValue === 'application/json'){
        config.data = {data:token.encryption(config.data)}
      }
    }
    config.headers.language = i18n.locale
    config.url = '/api' + config.url
    return config
  },
  error => {
    return error
  }
)

service.interceptors.response.use(
  response => {
    const resp = token.decode64(response.data)
    const res = JSON.parse(resp)
    //const res = response.data
    if (res.successful) {
      if (res.message) {
        Message.success(res.message)
      }
      return res.data
    } else {
      Message.error(res.message)
    }
    return null
  },
  error => {
    if (error && error.response) {
      switch (error.response.status) {
      case 400: Message.error(i18n.t('error.axios.400')); break
      case 401: goLogin(); break
      case 403: Message.error(i18n.t('error.axios.403')); break
      case 404: Message.error(i18n.t('error.axios.404')); break
      case 408: Message.error(i18n.t('error.axios.408')); break
      case 500: Message.error(i18n.t('error.axios.500')); break
      case 501: Message.error(i18n.t('error.axios.501')); break
      case 502: Message.error(i18n.t('error.axios.502')); break
      case 503: Message.error(i18n.t('error.axios.503')); break
      case 504: Message.error(i18n.t('error.axios.504')); break
      case 505: Message.error(i18n.t('error.axios.505')); break
      default: break
      }
    }
  }
)

export default service
